import { ApiClient } from "zoox-infra";
import { ReservationService } from "smck-service";

export default class WhatsAppOptInService {
  constructor() {
    this.apiClient = new ApiClient();
    this.reservationService = new ReservationService();
  }

  updatePersonFnrh(fnrhId, mobileCityCode, mobilePhoneNumber) {
    return this.apiClient.put(`external-access/fnrh/${fnrhId}`, {
      mobileCityCode,
      mobilePhoneNumber
    });
  }

  savePersonWppOptin(companyId, personId, isChecked) {
    this.apiClient.put(`open/term-accept/5/${companyId}/${personId}`, {
      is_checked: isChecked
    });
  }

  finalizeReservation(reservationId, guestId) {
    this.apiClient.put(`reservation/finalize/${reservationId}/${guestId}`, {
      reservationId: reservationId,
      guestId: guestId
    });

    this.reservationService.updateLocalGuest(guestId, { isFinalized: true });
  }
}
